export const RadiusButton = 4;
export const RadiusIcon = 4;
export const RadiusOption = 6;
export const RadiusOverlay = 10;
export const RadiusView = 8;
export const RadiusViewList = 10;
export const RadiusViewCard = 10;
